<p-table 
    [value]="trades()"
     size="small" 
    [rowHover]="true" 
    [lazy]="true" >
    
    <ng-template pTemplate="header">
        <tr class="bg-gray-50">
            <th class="text-bold">Data Contabile</th>
            <th class="text-bold">Tipologia</th>
            <th class="text-bold">Wallet</th>
            <th class="text-bold" style="text-align: right;">Quantità</th>
            <th class="text-bold" style="text-align: right;">Prezzo Unit.</th>
            <th class="text-bold" style="text-align: right;">Valore</th>
            <th class="text-bold" style="text-align: right;">Comm.</th>
            <th class="text-bold" style="text-align: right;">Totale</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-trade>
        <tr class="text-bold cursor-pointer" (click)="onSelect.emit(trade)">
            <td class="text-sm">{{ trade.accountingDate | date:'dd-MM-yyyy' }}</td>
            <td>
                @if (trade.quantity > 0) {
                    <p-tag value="Acquisto" severity="success" [rounded]="true"  />
                } @else if (trade.quantity < 0) {
                    <p-tag value="Vendita" severity="danger" [rounded]="true"  />
                } @else {
                    <p-tag value="Cedola" severity="info" [rounded]="true"  />
                }
            </td>
            <td class="text-sm text-gray-600">
                <div class="flex align-items-center gap-1">
                    <i class="pi pi-wallet text-[10px]"></i>
                    {{ walletStore.findReactive(trade.finWalletId)()?.shortDescription ?? 'N/D' }}
                </div>
            </td>
            <td class="text-right text-sm font-medium" style="text-align: right;">{{ trade.quantity }}</td>
            <td class="text-right text-sm" style="text-align: right;">{{ trade.purchaseValue | currency:'EUR' }}</td>
            <td class="text-right text-sm" style="text-align: right;">{{ trade.value | currency:'EUR' }}</td>
            <td class="text-right text-sm text-gray-400 italic" style="text-align: right;">{{ trade.commissionCost | currency:'EUR' }}</td>
            <td class="text-right text-sm font-bold text-gray-900 border-l border-gray-50" style="text-align: right;">{{ trade.taxedValue | currency:'EUR' }}</td>
        </tr>
    </ng-template>
</p-table>